import React from 'react'
import { PageHeader } from '@pushly/aqe/lib/components'
import { useParams } from 'react-router-dom'
import { AppState } from '../../../stores/app'
import { AppService } from '../../../services'
import { CatalogItemType } from '../types'
import { ItemGroupFormPage } from './item-group-form-page'
import { useService } from '@pushly/aqe/lib/hooks'

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getItemTypeLabel(itemType: CatalogItemType): string {
    switch (itemType) {
        case CatalogItemType.PRODUCT:
            return 'Product'
        case CatalogItemType.TICKETED_EVENT:
            return 'Event'
        case CatalogItemType.RECIPE:
            return 'Recipe'
        default:
            return 'Item'
    }
}

// ─── Page View ───────────────────────────────────────────────────────────────

/**
 * Thin page-level view for the Item Group create/edit route.
 * Provides the page header (title only) and delegates all form logic
 * to `ItemGroupFormPage`.
 */
export const ItemGroups: React.FC = () => {
    const appState = useService(AppState)
    const appService = useService(AppService)
    const { groupId } = useParams<{ groupId?: string }>()

    const isEditMode = !!groupId
    const domain = appState.currentDomain
    const itemType = domain?.ecommConfig?.itemType as CatalogItemType | undefined

    const modeLabel = isEditMode ? 'Edit' : 'Create'
    const pageTitle = itemType ? `${modeLabel} ${getItemTypeLabel(itemType)} Group` : `${modeLabel} Group`

    return (
        <div className="item-group-form-page">
            <PageHeader title={pageTitle} onTitleSet={appService.customizeTabTitle} />
            <ItemGroupFormPage />
        </div>
    )
}
